import axios from '@/plugins/axios'
import { Module } from 'vuex'
import { sortCollection, sortCollectionWithArray } from '@/utils/collections'

const campaignTagModule: Module<any, any> = {
    actions: {
        async initCampaignTagIndex() {
            if (this.campaignTagIndexLoading) {
        		await this.initCampaignTagPromise
        		return
        	}
            this.campaignTagIndexLoading = true
            this.initCampaignTagPromise = this.dispatch('initIndex', {
                id: 'campaignTag',
                idField: 'slug',
                indexedFields: ['slug', 'name'],
                source: '/api/campaign_tags',
                refresh: true,
            })
            await this.initCampaignTagPromise
            this.campaignTagIndexLoading = false
            this.initCampaignTagPromise = null
        },

        async getCampaignTags(_, params) {
            const indexExists = await this.dispatch('indexExists', 'campaignTag')

            if (!indexExists || params?.refresh) {
                await this.dispatch('initCampaignTagIndex')
            }

            const sortName = (items) => {
                return sortCollection(items, 'name', params?.sortOrder?.toLowerCase() === 'asc')
            }

            const sortMembers = (items) => {
                return sortCollectionWithArray(items, 'members', params?.sortOrder?.toLowerCase())
            }

            const sortContentCount = (items) => {
                return sortCollection(items, 'contentCount', params?.sortOrder?.toLowerCase() === 'asc')
            }
            
            const sortPosts = (items) => {
                return sortCollection(items, 'stats.postsDelivered', params?.sortOrder?.toLowerCase() === 'asc')
            }
            
            const sortEngagements = (items) => {
                return items?.sort((a, b) =>
                a?.stats.likes + a?.stats.comments + a?.stats.reshares < b?.stats.likes + b?.stats.comments + b?.stats.reshares
                    ? params?.sortOrder?.toLowerCase() === 'asc' ? -1 : 1
                    : a?.stats.likes + a?.stats.comments + a?.stats.reshares > b?.stats.likes + b?.stats.comments + b?.stats.reshares
                    ? params?.sortOrder?.toLowerCase() === 'asc' ? 1 : -1
                    : 0,
                )
            }
            
            const sortClicks = (items) => {                
                return sortCollection(items, 'stats.clicks', params?.sortOrder?.toLowerCase() === 'asc')
            }

            const sortMediaPoints = (items) => {
                return sortCollection(items, 'mediaPoints', params?.sortOrder?.toLowerCase() === 'asc')
            }

            const getSortOrder = () => {
                if (params?.sortBy === 'contentCount') {
                    return sortContentCount
                } else if (params?.sortBy === 'members') {
                    return sortMembers
                } else if (params?.sortBy === 'posts') {
                    return sortPosts
                } else if (params?.sortBy === 'engagements') {
                    return sortEngagements
                } else if (params?.sortBy === 'clicks') {
                    return sortClicks
                } else if (params?.sortBy === 'media_points') {
                    return sortMediaPoints
                } else {
                    return sortName
                }
            }

            let records = await this.dispatch('getRecords', {
                index: 'campaignTag',
                term: params?.search,
                fields: ['name'],
                page: params?.page ?? 1,
                perPage: params?.perPage ?? 10,
                filters: null,
                sort: getSortOrder()
            })

            if (!records || params?.hasContents) {
                const page = params?.page ? '&page=' + params.page : ''
                const perPage = params?.perPage
                    ? '&itemPerPage=' + params.perPage
                    : ''
                const hasContents = params?.hasContents ? '&hasContents=' + params?.hasContents : ''

                const { data } = await axios.get(
                    '/api/campaign_tags?' + page + perPage + hasContents,
                )

                records = {
                    items: data['hydra:member'],
                    count: data['hydra:totalItems'],
                }
            }

            return records
        },

        async getCampaignTag(_, id) {
            const { data } = await axios.get(`/api/campaign_tags/${id}`)
            return data
        },

        async createCampaignTag(_, params) {
            await axios.post('/api/campaign_tags', params)
        },

        async editCampaignTag(_, params) {
            const { data } = await axios.put(`/api/campaign_tags/${params.slug}`, params)
            return data

        },
        async deleteCampaignTag(_, params) {
            await axios.delete(`/api/campaign_tags/${params.slug}`)            
        },
    },
}

export default campaignTagModule
